
/**
 * @public
 */
export interface ISignal<T> {
    readonly resolve: (result?: T | Promise<T>) => void;
    readonly reject: (error: Error) => void;
    readonly promise: Promise<T>;
}

/**
 * @public
 */
export class Signal<T> implements ISignal<T> {
    public readonly promise: Promise<T>;
    public readonly resolve: (result?: T | Promise<T>) => void;
    public readonly reject: (error: Error) => void;

    constructor() {
        let resolveSignal: (result?: T | Promise<T>) => void;
        let rejectSignal: (error: Error) => void;

        this.promise = new Promise<T>((resolve: (result?: T | Promise<T>) => void, reject: (error: Error) => void) => {
            resolveSignal = resolve;
            rejectSignal = reject;
        });

        // tslint:disable-next-line:no-non-null-assertion
        this.resolve = resolveSignal!;
        // tslint:disable-next-line:no-non-null-assertion
        this.reject = rejectSignal!;
    }
}
